/**
 * Checks if value is Date.
 * @param value Value to check.
 * @returns True if value is Date; otherwise false.
 */
export function isDate(value: unknown): value is Date {
  return value instanceof Date;
}
